import { Disbursement, TransactionHistory, Wallet } from "./wallet";
import { DisbursementDraft, WalletDraft } from "./walletDraft";

export interface WalletDto extends Omit<WalletDraft, "currency"> {
	currency?: string;
}
export interface WalletFromDto extends Omit<WalletDraft, "currency"> {
	currency?: string;
}

export const walletToDto = (draft: WalletDraft): WalletDto => {
	return {
		...draft,
	};
};
export const walletFromDto = (dto: WalletDto): Wallet => {
	return {
		...dto,
	};
};

export const transactionFromDto = (dto: TransactionHistory): TransactionHistory => {
	return {
		...dto,
	};
};

export interface DisbursementDto extends Omit<DisbursementDraft, "id"> {
	id?: string;
}

export const disbursementToDto = (draft: DisbursementDraft): DisbursementDto => {
	return {
		...draft,
	};
};
export const disbursementFromDto = (dto: DisbursementDto): Disbursement => {
	// console.log("dto", dto)
	return {
		...dto,
	};
};
